import { useMutation, useQueryClient } from 'react-query';

import { addHubToObject as add } from 'api/traps/Hubs/addHubToObject';

const useAddHubToObj = () => {
  const queryClient = useQueryClient();
  const {
    isSuccess,
    mutate: addHubToObject,
    isLoading,
  } = useMutation(add, {
    onSuccess: () => {
      queryClient.refetchQueries('Hubs');
    },
  });

  return {
    isSuccess,
    addHubToObject,
    isLoading,
  };
};

export default useAddHubToObj;
